/**
 * Acquaintance
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Acquaintance
 */
var Acquaintance = 'http://www.w3.org/2006/vcard/ns#Acquaintance';
/**
 * Agent
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Agent
 */
var Agent = 'http://www.w3.org/2006/vcard/ns#Agent';
/**
 * BBS
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#BBS
 */
var BBS = 'http://www.w3.org/2006/vcard/ns#BBS';
/**
 * Car
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Car
 */
var Car = 'http://www.w3.org/2006/vcard/ns#Car';
/**
 * Cell
 *
 * Also called mobile telephone
 *
 * http://www.w3.org/2006/vcard/ns#Cell
 */
var Cell = 'http://www.w3.org/2006/vcard/ns#Cell';
/**
 * Child
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Child
 */
var Child = 'http://www.w3.org/2006/vcard/ns#Child';
/**
 * Colleague
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Colleague
 */
var Colleague = 'http://www.w3.org/2006/vcard/ns#Colleague';
/**
 * Contact
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Contact
 */
var Contact = 'http://www.w3.org/2006/vcard/ns#Contact';
/**
 * Coresident
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Coresident
 */
var Coresident = 'http://www.w3.org/2006/vcard/ns#Coresident';
/**
 * Coworker
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Coworker
 */
var Coworker = 'http://www.w3.org/2006/vcard/ns#Coworker';
/**
 * Crush
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Crush
 */
var Crush = 'http://www.w3.org/2006/vcard/ns#Crush';
/**
 * Date
 *
 * null
 * Note that `Date` is a reserved Javascript keyword, and is therefore suffixed by `__workaround`.
 * For a list of reserved keywords, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#Keywords.
 *
 * http://www.w3.org/2006/vcard/ns#Date
 */
var Date__workaround = 'http://www.w3.org/2006/vcard/ns#Date';
/**
 * Dom
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Dom
 */
var Dom = 'http://www.w3.org/2006/vcard/ns#Dom';
/**
 * Emergency
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Emergency
 */
var Emergency = 'http://www.w3.org/2006/vcard/ns#Emergency';
/**
 * Fax
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Fax
 */
var Fax = 'http://www.w3.org/2006/vcard/ns#Fax';
/**
 * Female
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Female
 */
var Female = 'http://www.w3.org/2006/vcard/ns#Female';
/**
 * Friend
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Friend
 */
var Friend = 'http://www.w3.org/2006/vcard/ns#Friend';
/**
 * Home
 *
 * This implies that the property is related to an individual's personal life
 *
 * http://www.w3.org/2006/vcard/ns#Home
 */
var Home = 'http://www.w3.org/2006/vcard/ns#Home';
/**
 * ISDN
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#ISDN
 */
var ISDN = 'http://www.w3.org/2006/vcard/ns#ISDN';
/**
 * Internet
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Internet
 */
var Internet = 'http://www.w3.org/2006/vcard/ns#Internet';
/**
 * Intl
 *
 * This class is deprecated
 * Note that `Intl` is a reserved Javascript keyword, and is therefore suffixed by `__workaround`.
 * For a list of reserved keywords, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#Keywords.
 *
 * http://www.w3.org/2006/vcard/ns#Intl
 */
var Intl__workaround = 'http://www.w3.org/2006/vcard/ns#Intl';
/**
 * Kin
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Kin
 */
var Kin = 'http://www.w3.org/2006/vcard/ns#Kin';
/**
 * Label
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Label
 */
var Label = 'http://www.w3.org/2006/vcard/ns#Label';
/**
 * Male
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Male
 */
var Male = 'http://www.w3.org/2006/vcard/ns#Male';
/**
 * Me
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Me
 */
var Me = 'http://www.w3.org/2006/vcard/ns#Me';
/**
 * Met
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Met
 */
var Met = 'http://www.w3.org/2006/vcard/ns#Met';
/**
 * Modem
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Modem
 */
var Modem = 'http://www.w3.org/2006/vcard/ns#Modem';
/**
 * Msg
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Msg
 */
var Msg = 'http://www.w3.org/2006/vcard/ns#Msg';
/**
 * Muse
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Muse
 */
var Muse = 'http://www.w3.org/2006/vcard/ns#Muse';
/**
 * Neighbor
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Neighbor
 */
var Neighbor = 'http://www.w3.org/2006/vcard/ns#Neighbor';
/**
 * None
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#None
 */
var None = 'http://www.w3.org/2006/vcard/ns#None';
/**
 * Other
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Other
 */
var Other = 'http://www.w3.org/2006/vcard/ns#Other';
/**
 * PCS
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#PCS
 */
var PCS = 'http://www.w3.org/2006/vcard/ns#PCS';
/**
 * Pager
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Pager
 */
var Pager = 'http://www.w3.org/2006/vcard/ns#Pager';
/**
 * Parcel
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Parcel
 */
var Parcel = 'http://www.w3.org/2006/vcard/ns#Parcel';
/**
 * Parent
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Parent
 */
var Parent = 'http://www.w3.org/2006/vcard/ns#Parent';
/**
 * Postal
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Postal
 */
var Postal = 'http://www.w3.org/2006/vcard/ns#Postal';
/**
 * Pref
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#Pref
 */
var Pref = 'http://www.w3.org/2006/vcard/ns#Pref';
/**
 * Sibling
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Sibling
 */
var Sibling = 'http://www.w3.org/2006/vcard/ns#Sibling';
/**
 * Spouse
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Spouse
 */
var Spouse = 'http://www.w3.org/2006/vcard/ns#Spouse';
/**
 * Sweetheart
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Sweetheart
 */
var Sweetheart = 'http://www.w3.org/2006/vcard/ns#Sweetheart';
/**
 * Tel
 *
 * This class is deprecated. Use the hasTelephone object property.
 *
 * http://www.w3.org/2006/vcard/ns#Tel
 */
var Tel = 'http://www.w3.org/2006/vcard/ns#Tel';
/**
 * Text
 *
 * Also called sms telephone
 *
 * http://www.w3.org/2006/vcard/ns#Text
 */
var Text = 'http://www.w3.org/2006/vcard/ns#Text';
/**
 * Text phone
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#TextPhone
 */
var TextPhone = 'http://www.w3.org/2006/vcard/ns#TextPhone';
/**
 * Unknown
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Unknown
 */
var Unknown = 'http://www.w3.org/2006/vcard/ns#Unknown';
/**
 * Video
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Video
 */
var Video = 'http://www.w3.org/2006/vcard/ns#Video';
/**
 * Voice
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Voice
 */
var Voice = 'http://www.w3.org/2006/vcard/ns#Voice';
/**
 * Work
 *
 * This implies that the property is related to an individual's work place
 *
 * http://www.w3.org/2006/vcard/ns#Work
 */
var Work = 'http://www.w3.org/2006/vcard/ns#Work';
/**
 * X400
 *
 * This class is deprecated
 *
 * http://www.w3.org/2006/vcard/ns#X400
 */
var X400 = 'http://www.w3.org/2006/vcard/ns#X400';
/**
 * Address
 *
 * To specify the components of the delivery address for the  object
 *
 * http://www.w3.org/2006/vcard/ns#Address
 */
var Address = 'http://www.w3.org/2006/vcard/ns#Address';
/**
 * Email
 *
 * To specify the electronic mail address for communication with the object the vCard represents. Use the hasEmail object property.
 *
 * http://www.w3.org/2006/vcard/ns#Email
 */
var Email = 'http://www.w3.org/2006/vcard/ns#Email';
/**
 * Group
 *
 * Object representing a group of persons or entities.  A group object will usually contain hasMember properties to specify the members of the group.
 *
 * http://www.w3.org/2006/vcard/ns#Group
 */
var Group = 'http://www.w3.org/2006/vcard/ns#Group';
/**
 * Individual
 *
 * An object representing a single person or entity
 *
 * http://www.w3.org/2006/vcard/ns#Individual
 */
var Individual = 'http://www.w3.org/2006/vcard/ns#Individual';
/**
 * Name
 *
 * To specify the components of the name of the object
 *
 * http://www.w3.org/2006/vcard/ns#Name
 */
var Name = 'http://www.w3.org/2006/vcard/ns#Name';
/**
 * VCard
 *
 * The vCard class is  equivalent to the new Kind class, which is the parent for the four explicit types of vCards (Individual, Organization, Location, Group)
 *
 * http://www.w3.org/2006/vcard/ns#VCard
 */
var VCard = 'http://www.w3.org/2006/vcard/ns#VCard';
/**
 * Location
 *
 * An object representing a named geographical place
 *
 * http://www.w3.org/2006/vcard/ns#Location
 */
var Location = 'http://www.w3.org/2006/vcard/ns#Location';
/**
 * Organization
 *
 * An object representing an organization.  An organization is a single entity, and might represent a business or government, a department or division within a business or government, a club, an association, or the like.
 *
 *
 * http://www.w3.org/2006/vcard/ns#Organization
 */
var Organization = 'http://www.w3.org/2006/vcard/ns#Organization';
/**
 * Gender
 *
 * Used for gender codes. The URI of the gender code must be used as the value for Gender.
 *
 * http://www.w3.org/2006/vcard/ns#Gender
 */
var Gender = 'http://www.w3.org/2006/vcard/ns#Gender';
/**
 * Kind
 *
 * The parent class for all objects
 *
 * http://www.w3.org/2006/vcard/ns#Kind
 */
var Kind = 'http://www.w3.org/2006/vcard/ns#Kind';
/**
 * Type
 *
 * Used for type codes. The URI of the type code must be used as the value for Type.
 *
 * http://www.w3.org/2006/vcard/ns#Type
 */
var Type = 'http://www.w3.org/2006/vcard/ns#Type';
/**
 * Phone
 *
 * Used for telephone type codes. The URI of the telephone type code must be used as the value for the Telephone Type.
 *
 * http://www.w3.org/2006/vcard/ns#TelephoneType
 */
var TelephoneType = 'http://www.w3.org/2006/vcard/ns#TelephoneType';
/**
 * Relation Type
 *
 * Used for relation type codes. The URI of the relation type code must be used as the value for the Relation Type.
 *
 * http://www.w3.org/2006/vcard/ns#RelatedType
 */
var RelatedType = 'http://www.w3.org/2006/vcard/ns#RelatedType';
/**
 * address
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#adr
 */
var adr = 'http://www.w3.org/2006/vcard/ns#adr';
/**
 * agent
 *
 * This object property has been deprecated
 *
 * http://www.w3.org/2006/vcard/ns#agent
 */
var agent = 'http://www.w3.org/2006/vcard/ns#agent';
/**
 * email
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#email
 */
var email = 'http://www.w3.org/2006/vcard/ns#email';
/**
 * geo
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#geo
 */
var geo = 'http://www.w3.org/2006/vcard/ns#geo';
/**
 * has additional name
 *
 * Used to support property parameters for the additional name data property
 *
 * http://www.w3.org/2006/vcard/ns#hasAdditionalName
 */
var hasAdditionalName = 'http://www.w3.org/2006/vcard/ns#hasAdditionalName';
/**
 * has calendar busy
 *
 * To specify the busy time associated with the object. (Was called FBURL in RFC6350)
 *
 * http://www.w3.org/2006/vcard/ns#hasCalendarBusy
 */
var hasCalendarBusy = 'http://www.w3.org/2006/vcard/ns#hasCalendarBusy';
/**
 * has calendar link
 *
 * To specify the calendar associated with the object. (Was called CALURI in RFC6350)
 *
 * http://www.w3.org/2006/vcard/ns#hasCalendarLink
 */
var hasCalendarLink = 'http://www.w3.org/2006/vcard/ns#hasCalendarLink';
/**
 * has calendar request
 *
 * To specify the calendar user address to which a scheduling request be sent for the object. (Was called CALADRURI in RFC6350)
 *
 * http://www.w3.org/2006/vcard/ns#hasCalendarRequest
 */
var hasCalendarRequest = 'http://www.w3.org/2006/vcard/ns#hasCalendarRequest';
/**
 * has category
 *
 * Used to support property parameters for the category data property
 *
 * http://www.w3.org/2006/vcard/ns#hasCategory
 */
var hasCategory = 'http://www.w3.org/2006/vcard/ns#hasCategory';
/**
 * has country name
 *
 * Used to support property parameters for the country name data property
 *
 * http://www.w3.org/2006/vcard/ns#hasCountryName
 */
var hasCountryName = 'http://www.w3.org/2006/vcard/ns#hasCountryName';
/**
 * has formatted name
 *
 * Used to support property parameters for the formatted name data property
 *
 * http://www.w3.org/2006/vcard/ns#hasFN
 */
var hasFN = 'http://www.w3.org/2006/vcard/ns#hasFN';
/**
 * has family name
 *
 * Used to support property parameters for the family name data property
 *
 * http://www.w3.org/2006/vcard/ns#hasFamilyName
 */
var hasFamilyName = 'http://www.w3.org/2006/vcard/ns#hasFamilyName';
/**
 * has gender
 *
 * To specify  the sex or gender identity of the object. URIs are recommended to enable interoperable sex and gender codes to be used.
 *
 * http://www.w3.org/2006/vcard/ns#hasGender
 */
var hasGender = 'http://www.w3.org/2006/vcard/ns#hasGender';
/**
 * has given name
 *
 * Used to support property parameters for the given name data property
 *
 * http://www.w3.org/2006/vcard/ns#hasGivenName
 */
var hasGivenName = 'http://www.w3.org/2006/vcard/ns#hasGivenName';
/**
 * has honorific prefix
 *
 * Used to support property parameters for the honorific prefix data property
 *
 * http://www.w3.org/2006/vcard/ns#hasHonorificPrefix
 */
var hasHonorificPrefix = 'http://www.w3.org/2006/vcard/ns#hasHonorificPrefix';
/**
 * has honorific suffix
 *
 * Used to support property parameters for the honorific suffix data property
 *
 * http://www.w3.org/2006/vcard/ns#hasHonorificSuffix
 */
var hasHonorificSuffix = 'http://www.w3.org/2006/vcard/ns#hasHonorificSuffix';
/**
 * has messaging
 *
 * To specify the instant messaging and presence protocol communications with the object. (Was called IMPP in RFC6350)
 *
 * http://www.w3.org/2006/vcard/ns#hasInstantMessage
 */
var hasInstantMessage = 'http://www.w3.org/2006/vcard/ns#hasInstantMessage';
/**
 * has language
 *
 * Used to support property parameters for the language data property
 *
 * http://www.w3.org/2006/vcard/ns#hasLanguage
 */
var hasLanguage = 'http://www.w3.org/2006/vcard/ns#hasLanguage';
/**
 * has locality
 *
 * Used to support property parameters for the locality data property
 *
 * http://www.w3.org/2006/vcard/ns#hasLocality
 */
var hasLocality = 'http://www.w3.org/2006/vcard/ns#hasLocality';
/**
 * has nickname
 *
 * Used to support property parameters for the nickname data property
 *
 * http://www.w3.org/2006/vcard/ns#hasNickname
 */
var hasNickname = 'http://www.w3.org/2006/vcard/ns#hasNickname';
/**
 * has note
 *
 * Used to support property parameters for the note data property
 *
 * http://www.w3.org/2006/vcard/ns#hasNote
 */
var hasNote = 'http://www.w3.org/2006/vcard/ns#hasNote';
/**
 * has organization name
 *
 * Used to support property parameters for the organization name data property
 *
 * http://www.w3.org/2006/vcard/ns#hasOrganizationName
 */
var hasOrganizationName = 'http://www.w3.org/2006/vcard/ns#hasOrganizationName';
/**
 * has organization unit name
 *
 * Used to support property parameters for the organization unit name data property
 *
 * http://www.w3.org/2006/vcard/ns#hasOrganizationUnit
 */
var hasOrganizationUnit = 'http://www.w3.org/2006/vcard/ns#hasOrganizationUnit';
/**
 * has postal code
 *
 * Used to support property parameters for the postal code data property
 *
 * http://www.w3.org/2006/vcard/ns#hasPostalCode
 */
var hasPostalCode = 'http://www.w3.org/2006/vcard/ns#hasPostalCode';
/**
 * has region
 *
 * Used to support property parameters for the region data property
 *
 * http://www.w3.org/2006/vcard/ns#hasRegion
 */
var hasRegion = 'http://www.w3.org/2006/vcard/ns#hasRegion';
/**
 * has related
 *
 * To specify a relationship between another entity and the entity represented by this object
 *
 * http://www.w3.org/2006/vcard/ns#hasRelated
 */
var hasRelated = 'http://www.w3.org/2006/vcard/ns#hasRelated';
/**
 * has role
 *
 * Used to support property parameters for the role data property
 *
 * http://www.w3.org/2006/vcard/ns#hasRole
 */
var hasRole = 'http://www.w3.org/2006/vcard/ns#hasRole';
/**
 * has source
 *
 * To identify the source of directory information of the object
 *
 * http://www.w3.org/2006/vcard/ns#hasSource
 */
var hasSource = 'http://www.w3.org/2006/vcard/ns#hasSource';
/**
 * has street address
 *
 * Used to support property parameters for the street address data property
 *
 * http://www.w3.org/2006/vcard/ns#hasStreetAddress
 */
var hasStreetAddress = 'http://www.w3.org/2006/vcard/ns#hasStreetAddress';
/**
 * has title
 *
 * Used to support property parameters for the title data property
 *
 * http://www.w3.org/2006/vcard/ns#hasTitle
 */
var hasTitle = 'http://www.w3.org/2006/vcard/ns#hasTitle';
/**
 * has uid
 *
 * To specify a value that represents a globally unique identifier corresponding to the object
 *
 * http://www.w3.org/2006/vcard/ns#hasUID
 */
var hasUID = 'http://www.w3.org/2006/vcard/ns#hasUID';
/**
 * has value
 *
 * Used to indicate the resource value of an object property that requires property parameters
 *
 * http://www.w3.org/2006/vcard/ns#hasValue
 */
var hasValue = 'http://www.w3.org/2006/vcard/ns#hasValue';
/**
 * organization
 *
 * This object property has been mapped. Use the organization-name data property.
 *
 * http://www.w3.org/2006/vcard/ns#org
 */
var org = 'http://www.w3.org/2006/vcard/ns#org';
/**
 * has address
 *
 * To specify the components of the delivery address for the object
 *
 * http://www.w3.org/2006/vcard/ns#hasAddress
 */
var hasAddress = 'http://www.w3.org/2006/vcard/ns#hasAddress';
/**
 * has email
 *
 * To specify the electronic mail address for communication with the object
 *
 * http://www.w3.org/2006/vcard/ns#hasEmail
 */
var hasEmail = 'http://www.w3.org/2006/vcard/ns#hasEmail';
/**
 * has geo
 *
 * To specify information related to the global positioning of the object. May also be used as a property parameter.
 *
 * http://www.w3.org/2006/vcard/ns#hasGeo
 */
var hasGeo = 'http://www.w3.org/2006/vcard/ns#hasGeo';
/**
 * has key
 *
 * To specify a public key or authentication certificate associated with the object
 *
 * http://www.w3.org/2006/vcard/ns#hasKey
 */
var hasKey = 'http://www.w3.org/2006/vcard/ns#hasKey';
/**
 * has logo
 *
 * To specify a graphic image of a logo associated with the object
 *
 * http://www.w3.org/2006/vcard/ns#hasLogo
 */
var hasLogo = 'http://www.w3.org/2006/vcard/ns#hasLogo';
/**
 * has name
 *
 * To specify the components of the name of the object
 *
 * http://www.w3.org/2006/vcard/ns#hasName
 */
var hasName = 'http://www.w3.org/2006/vcard/ns#hasName';
/**
 * has photo
 *
 * To specify an image or photograph information that annotates some aspect of the object
 *
 * http://www.w3.org/2006/vcard/ns#hasPhoto
 */
var hasPhoto = 'http://www.w3.org/2006/vcard/ns#hasPhoto';
/**
 * has sound
 *
 * To specify a digital sound content information that annotates some aspect of the object
 *
 * http://www.w3.org/2006/vcard/ns#hasSound
 */
var hasSound = 'http://www.w3.org/2006/vcard/ns#hasSound';
/**
 * has telephone
 *
 * To specify the telephone number for telephony communication with the object
 *
 * http://www.w3.org/2006/vcard/ns#hasTelephone
 */
var hasTelephone = 'http://www.w3.org/2006/vcard/ns#hasTelephone';
/**
 * has url
 *
 * To specify a uniform resource locator associated with the object
 *
 * http://www.w3.org/2006/vcard/ns#hasURL
 */
var hasURL = 'http://www.w3.org/2006/vcard/ns#hasURL';
/**
 * key
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#key
 */
var key = 'http://www.w3.org/2006/vcard/ns#key';
/**
 * logo
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#logo
 */
var logo = 'http://www.w3.org/2006/vcard/ns#logo';
/**
 * name
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#n
 */
var n = 'http://www.w3.org/2006/vcard/ns#n';
/**
 * photo
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#photo
 */
var photo = 'http://www.w3.org/2006/vcard/ns#photo';
/**
 * sound
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#sound
 */
var sound = 'http://www.w3.org/2006/vcard/ns#sound';
/**
 * telephone
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#tel
 */
var tel = 'http://www.w3.org/2006/vcard/ns#tel';
/**
 * url
 *
 * This object property has been mapped
 *
 * http://www.w3.org/2006/vcard/ns#url
 */
var url = 'http://www.w3.org/2006/vcard/ns#url';
/**
 * has member
 *
 * To include a member in the group this object represents. (This property can only be used by Group individuals)
 *
 * http://www.w3.org/2006/vcard/ns#hasMember
 */
var hasMember = 'http://www.w3.org/2006/vcard/ns#hasMember';
/**
 * anniversary
 *
 * The date of marriage, or equivalent, of the object
 *
 * http://www.w3.org/2006/vcard/ns#anniversary
 */
var anniversary = 'http://www.w3.org/2006/vcard/ns#anniversary';
/**
 * birth date
 *
 * To specify the birth date of the object
 *
 * http://www.w3.org/2006/vcard/ns#bday
 */
var bday = 'http://www.w3.org/2006/vcard/ns#bday';
/**
 * category
 *
 * The category information about the object, also known as tags
 *
 * http://www.w3.org/2006/vcard/ns#category
 */
var category = 'http://www.w3.org/2006/vcard/ns#category';
/**
 * class
 *
 * This data property has been deprecated
 * Note that `class` is a reserved Javascript keyword, and is therefore suffixed by `__workaround`.
 * For a list of reserved keywords, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#Keywords.
 *
 * http://www.w3.org/2006/vcard/ns#class
 */
var class__workaround = 'http://www.w3.org/2006/vcard/ns#class';
/**
 * label
 *
 * This data property has been deprecated
 *
 * http://www.w3.org/2006/vcard/ns#label
 */
var label = 'http://www.w3.org/2006/vcard/ns#label';
/**
 * language
 *
 * To specify the language that may be used for contacting the object. May also be used as a property parameter.
 *
 * http://www.w3.org/2006/vcard/ns#language
 */
var language = 'http://www.w3.org/2006/vcard/ns#language';
/**
 * latitude
 *
 * This data property has been deprecated. See hasGeo
 *
 * http://www.w3.org/2006/vcard/ns#latitude
 */
var latitude = 'http://www.w3.org/2006/vcard/ns#latitude';
/**
 * longitude
 *
 * This data property has been deprecated. See hasGeo
 *
 * http://www.w3.org/2006/vcard/ns#longitude
 */
var longitude = 'http://www.w3.org/2006/vcard/ns#longitude';
/**
 * mailer
 *
 * This data property has been deprecated
 *
 * http://www.w3.org/2006/vcard/ns#mailer
 */
var mailer = 'http://www.w3.org/2006/vcard/ns#mailer';
/**
 * note
 *
 * A note associated with the object
 *
 * http://www.w3.org/2006/vcard/ns#note
 */
var note = 'http://www.w3.org/2006/vcard/ns#note';
/**
 * product id
 *
 * To specify the identifier for the product that created the object
 *
 * http://www.w3.org/2006/vcard/ns#prodid
 */
var prodid = 'http://www.w3.org/2006/vcard/ns#prodid';
/**
 * revision
 *
 * To specify revision information about the object
 *
 * http://www.w3.org/2006/vcard/ns#rev
 */
var rev = 'http://www.w3.org/2006/vcard/ns#rev';
/**
 * role
 *
 * To specify the function or part played in a particular situation by the object
 *
 * http://www.w3.org/2006/vcard/ns#role
 */
var role = 'http://www.w3.org/2006/vcard/ns#role';
/**
 * title
 *
 * To specify the position or job of the object
 *
 * http://www.w3.org/2006/vcard/ns#title
 */
var title = 'http://www.w3.org/2006/vcard/ns#title';
/**
 * time zone
 *
 * To indicate time zone information that is specific to the object. May also be used as a property parameter.
 *
 * http://www.w3.org/2006/vcard/ns#tz
 */
var tz = 'http://www.w3.org/2006/vcard/ns#tz';
/**
 * value
 *
 * Used to indicate the literal value of a data property that requires property parameters
 *
 * http://www.w3.org/2006/vcard/ns#value
 */
var value = 'http://www.w3.org/2006/vcard/ns#value';
/**
 * formatted name
 *
 * The formatted text corresponding to the name of the object
 *
 * http://www.w3.org/2006/vcard/ns#fn
 */
var fn = 'http://www.w3.org/2006/vcard/ns#fn';
/**
 * nickname
 *
 * The nick name associated with the object
 *
 * http://www.w3.org/2006/vcard/ns#nickname
 */
var nickname = 'http://www.w3.org/2006/vcard/ns#nickname';
/**
 * locality
 *
 * The locality (e.g. city or town) associated with the address of the object
 *
 * http://www.w3.org/2006/vcard/ns#locality
 */
var locality = 'http://www.w3.org/2006/vcard/ns#locality';
/**
 * region
 *
 * The region (e.g. state or province) associated with the address of the object
 *
 * http://www.w3.org/2006/vcard/ns#region
 */
var region = 'http://www.w3.org/2006/vcard/ns#region';

var vcardImport = /*#__PURE__*/Object.freeze({
	Acquaintance: Acquaintance,
	Agent: Agent,
	BBS: BBS,
	Car: Car,
	Cell: Cell,
	Child: Child,
	Colleague: Colleague,
	Contact: Contact,
	Coresident: Coresident,
	Coworker: Coworker,
	Crush: Crush,
	Date__workaround: Date__workaround,
	Dom: Dom,
	Emergency: Emergency,
	Fax: Fax,
	Female: Female,
	Friend: Friend,
	Home: Home,
	ISDN: ISDN,
	Internet: Internet,
	Intl__workaround: Intl__workaround,
	Kin: Kin,
	Label: Label,
	Male: Male,
	Me: Me,
	Met: Met,
	Modem: Modem,
	Msg: Msg,
	Muse: Muse,
	Neighbor: Neighbor,
	None: None,
	Other: Other,
	PCS: PCS,
	Pager: Pager,
	Parcel: Parcel,
	Parent: Parent,
	Postal: Postal,
	Pref: Pref,
	Sibling: Sibling,
	Spouse: Spouse,
	Sweetheart: Sweetheart,
	Tel: Tel,
	Text: Text,
	TextPhone: TextPhone,
	Unknown: Unknown,
	Video: Video,
	Voice: Voice,
	Work: Work,
	X400: X400,
	Address: Address,
	Email: Email,
	Group: Group,
	Individual: Individual,
	Name: Name,
	VCard: VCard,
	Location: Location,
	Organization: Organization,
	Gender: Gender,
	Kind: Kind,
	Type: Type,
	TelephoneType: TelephoneType,
	RelatedType: RelatedType,
	adr: adr,
	agent: agent,
	email: email,
	geo: geo,
	hasAdditionalName: hasAdditionalName,
	hasCalendarBusy: hasCalendarBusy,
	hasCalendarLink: hasCalendarLink,
	hasCalendarRequest: hasCalendarRequest,
	hasCategory: hasCategory,
	hasCountryName: hasCountryName,
	hasFN: hasFN,
	hasFamilyName: hasFamilyName,
	hasGender: hasGender,
	hasGivenName: hasGivenName,
	hasHonorificPrefix: hasHonorificPrefix,
	hasHonorificSuffix: hasHonorificSuffix,
	hasInstantMessage: hasInstantMessage,
	hasLanguage: hasLanguage,
	hasLocality: hasLocality,
	hasNickname: hasNickname,
	hasNote: hasNote,
	hasOrganizationName: hasOrganizationName,
	hasOrganizationUnit: hasOrganizationUnit,
	hasPostalCode: hasPostalCode,
	hasRegion: hasRegion,
	hasRelated: hasRelated,
	hasRole: hasRole,
	hasSource: hasSource,
	hasStreetAddress: hasStreetAddress,
	hasTitle: hasTitle,
	hasUID: hasUID,
	hasValue: hasValue,
	org: org,
	hasAddress: hasAddress,
	hasEmail: hasEmail,
	hasGeo: hasGeo,
	hasKey: hasKey,
	hasLogo: hasLogo,
	hasName: hasName,
	hasPhoto: hasPhoto,
	hasSound: hasSound,
	hasTelephone: hasTelephone,
	hasURL: hasURL,
	key: key,
	logo: logo,
	n: n,
	photo: photo,
	sound: sound,
	tel: tel,
	url: url,
	hasMember: hasMember,
	anniversary: anniversary,
	bday: bday,
	category: category,
	class__workaround: class__workaround,
	label: label,
	language: language,
	latitude: latitude,
	longitude: longitude,
	mailer: mailer,
	note: note,
	prodid: prodid,
	rev: rev,
	role: role,
	title: title,
	tz: tz,
	value: value,
	fn: fn,
	nickname: nickname,
	locality: locality,
	region: region
});

export { Name as $, Acquaintance as A, BBS as B, Car as C, Date__workaround as D, Emergency as E, Fax as F, Text as G, Home as H, ISDN as I, TextPhone as J, Kin as K, Label as L, Male as M, Neighbor as N, Other as O, PCS as P, Voice as Q, Address as R, Sibling as S, Tel as T, Unknown as U, Video as V, Work as W, X400 as X, Email as Y, Group as Z, Individual as _, Agent as a, label as a$, VCard as a0, Location as a1, Organization as a2, Gender as a3, Kind as a4, Type as a5, TelephoneType as a6, RelatedType as a7, adr as a8, agent as a9, hasStreetAddress as aA, hasTitle as aB, hasUID as aC, hasValue as aD, org as aE, hasAddress as aF, hasEmail as aG, hasGeo as aH, hasKey as aI, hasLogo as aJ, hasName as aK, hasPhoto as aL, hasSound as aM, hasTelephone as aN, hasURL as aO, key as aP, logo as aQ, n as aR, photo as aS, sound as aT, tel as aU, url as aV, hasMember as aW, anniversary as aX, bday as aY, category as aZ, class__workaround as a_, email as aa, geo as ab, hasAdditionalName as ac, hasCalendarBusy as ad, hasCalendarLink as ae, hasCalendarRequest as af, hasCategory as ag, hasCountryName as ah, hasFN as ai, hasFamilyName as aj, hasGender as ak, hasGivenName as al, hasHonorificPrefix as am, hasHonorificSuffix as an, hasInstantMessage as ao, hasLanguage as ap, hasLocality as aq, hasNickname as ar, hasNote as as, hasOrganizationName as at, hasOrganizationUnit as au, hasPostalCode as av, hasRegion as aw, hasRelated as ax, hasRole as ay, hasSource as az, Cell as b, language as b0, latitude as b1, longitude as b2, mailer as b3, note as b4, prodid as b5, rev as b6, role as b7, title as b8, tz as b9, value as ba, fn as bb, nickname as bc, locality as bd, region as be, vcardImport as bf, Child as c, Colleague as d, Contact as e, Coresident as f, Coworker as g, Crush as h, Dom as i, Female as j, Friend as k, Internet as l, Intl__workaround as m, Me as n, Met as o, Modem as p, Msg as q, Muse as r, None as s, Pager as t, Parcel as u, Parent as v, Postal as w, Pref as x, Spouse as y, Sweetheart as z };
